interface LoginPageProps {
  onLogin: () => void;
}

export function LoginPage({ onLogin }: LoginPageProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-sm space-y-6 text-center">
        <h1 className="text-3xl font-bold text-gray-900">Deft</h1>
        <p className="text-gray-600">Your AI workplace agent</p>
        <button
          type="button"
          onClick={onLogin}
          className="w-full rounded-lg bg-gray-900 px-4 py-3 text-white transition-colors hover:bg-gray-800"
        >
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
